import React, {CSSProperties} from 'react'
import { FC } from 'react'

type LProps = {
  text?: string | any,
  className?: string,
  style?: CSSProperties
}
const  CustomLabel: FC<LProps> = ({style, text , className='fs-5 mb-3 ' }) => {
  return (
      <div className={className}>
        <span style={style} >{text} </span>
      </div>
  )
}

export const  CustomGroupeLabel: FC<LProps> = ({ style, text , className='fs-5 mb-3 fw-bolder text-dark ' }) => {
  return (
    <div className={className}>
      <span style={style} >{text} </span>
    </div>
  )
}

export default CustomLabel
